import { ItemFormFilling, SubItemFormFilling } from "../Filling/Types";

const setNaoOk = () => {
  return "naoOk";
};
const setOk = () => {
  return "ok";
};

export function CheckIconItem(item: ItemFormFilling) {
  if (item.subitens.some((ele) => ele.obrigatoriedade?.preenchimento && !ele.checked)) {
    return "naoOk";
  }
  if (item.subitens.some((ele) => ele.obrigatoriedade?.preenchimento && ele.checked)) {
    return "ok";
  }
  if (item.subitens.some((ele) => !ele.obrigatoriedade?.preenchimento)) {
    if (item.subitens?.every((ele) => !ele.checked)) {
      return "default";
    }
    if (item.subitens?.some((ele) => ele.checked)) {
      return "ok";
    }
  }
  return "default";
}

export default function CheckIcon(subItem: SubItemFormFilling, value?: string | string[] | null | { texto: string }[] | Date | any) {
  const regexEmail = /^(?![.-])([A-Za-z0-9._%+-]+(?:(?<=.)[A-Za-z0-9._%+-]))@[A-Za-z0-9.-]+\.[A-Za-z]{1,}$/;
  const obriga = subItem.obrigatoriedade?.preenchimento;
  if (subItem?.tipo === "avaliacao") {
    if (subItem.obrigatoriedade?.preenchimento) {
      if (subItem.nota === undefined) {
        return setNaoOk();
      }
    }
    if (subItem.nota !== undefined && (subItem.threshold || subItem.threshold === 0)) {
      if (subItem?.nota > subItem?.threshold) {
        if (!subItem.hideImg && subItem.obrigatoriedade?.conforme?.img && (!subItem.img || !subItem.img?.length)) {
          return setNaoOk();
        }
        if (!subItem.hideComent && subItem.obrigatoriedade?.conforme.ocorrencia && (!subItem.ocorrencia || !subItem.ocorrencia?.length)) {
          return setNaoOk();
        }
      }
      if (subItem?.nota <= subItem?.threshold) {
        if (!subItem.hideImg && subItem.obrigatoriedade?.naoConforme.img && (!subItem.img || !subItem.img?.length)) {
          return setNaoOk();
        }
        if (!subItem.hideComent && subItem.obrigatoriedade?.naoConforme.ocorrencia && (!subItem.ocorrencia || !subItem.ocorrencia?.length)) {
          return setNaoOk();
        }
      }
      if (!subItem.hideImg && subItem.obrigatoriedade?.NA?.img && subItem.nota === -1) {
        if (!subItem?.img || !subItem.img?.length) {
          return setNaoOk();
        }
        if (!subItem.hideComent && subItem.obrigatoriedade?.NA?.ocorrencia && subItem.nota === -1) {
          if (!subItem?.ocorrencia || !subItem.ocorrencia?.length) {
            return setNaoOk();
          }
        }
      }
      return setOk();
    }
  }
  if (subItem?.obrigatoriedade?.ocorrencia) {
    if (subItem.tipo === "multiple") {
      if (value && !subItem?.ocorrencia) {
        return setNaoOk();
      }
    } else if (value && !subItem?.obs) {
      return setNaoOk();
    }
  }
  if (subItem?.obrigatoriedade?.img) {
    if ((value && !subItem.img) || !subItem.img?.length) {
      return setNaoOk();
    }
  }
  switch (subItem?.tipo) {
    case "unique":
    case "multiple":
    case "list":
    case "textoCurto":
    case "textoLongo":
    case "assinatura":
    case "data":
    case "hora":
      if (obriga) {
        if (!value) {
          return setNaoOk();
        }
      }
      if (value) {
        return setOk();
      }
      break;
    case "numero":
      if (obriga) {
        if (!Number(value)) {
          return setNaoOk();
        }
        if (value && subItem.maxNumberVal) {
          if (Number(value) > subItem?.maxNumberVal) {
            return setNaoOk();
          }
        }
        if (value && subItem.minNumberVal) {
          if (Number(value) < subItem?.minNumberVal) {
            return setNaoOk();
          }
        }
      }
      if (value && subItem.maxNumberVal) {
        if (Number(value) > subItem?.maxNumberVal) {
          return setNaoOk();
        }
      }
      if (value && subItem.minNumberVal) {
        if (Number(value) < subItem?.minNumberVal) {
          return setNaoOk();
        }
      }
      if (value) {
        return setOk();
      }
      break;
    case "rg":
      if (obriga) {
        if (value?.length !== 12) {
          return setNaoOk();
        }
      }
      if (value && value?.length !== 12) {
        return setNaoOk();
      }
      if (value && value?.length === 12) {
        return setOk();
      }
      break;
    case "email":
      if (obriga) {
        if (!regexEmail?.test(value as string)) {
          return setNaoOk();
        }
      }
      if (value && !regexEmail?.test(value as string)) {
        return setNaoOk();
      }
      if (value) {
        return setOk();
      }
      break;
    case "cpfcnpj":
      if (obriga) {
        if (![14, 18].includes(value?.length as number)) {
          return setNaoOk();
        }
      }
      if (value && ![14, 18].includes(value?.length as number)) {
        return setNaoOk();
      }
      if (value && [14, 18].includes(value?.length as number)) {
        return setOk();
      }
      break;
    case "cep":
      if (obriga) {
        if (value?.length !== 9) {
          return setNaoOk();
        }
      }
      if (value && value?.length !== 9) {
        return setNaoOk();
      }
      if (value?.length === 9) return setOk();
      break;
    case "telefone":
      if (obriga) {
        if (![12, 13].includes(value?.length as number)) {
          return setNaoOk();
        }
      }
      if (value && ![12, 13].includes(value?.length as number)) {
        return setNaoOk();
      }
      if (value && [12, 13].includes(value?.length as number)) {
        return setOk();
      }
      break;
    case "placa":
      if (obriga) {
        if (![8].includes(value?.length)) {
          return setNaoOk();
        }
      }
      if (value && ![8].includes(value?.length)) {
        return setNaoOk();
      }
      if (value) return setOk();
      break;
    case "avaliacao":
      if (obriga) {
        if (typeof value !== "number") {
          return setNaoOk();
        }
        if (typeof value === "number") {
          return setOk();
        }
      }
      if (typeof value === "number") {
        return setOk();
      }
      if (value === null) {
        return "default";
      }
      break;
    default:
      if (value) return setOk();
  }
  return "default";
}
